<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <SyncServices />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import SyncServices from '@/components/sync/SyncServices.vue'

  export default {
    name: 'SyncServicesView',
    components: {
      PageTitle,
      PageRowWrapper,
      SyncServices
    }
  }
</script>
